import React, { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useSelector } from 'react-redux';

import { useGetRecordQuery } from '../../features/whyriiseApiSlice';
import { selectCurrentLanguage } from '../../features/langSlice';
import { WhyRiiseTitle, DoINeedAboLabel, DoINeedAboAnswer } from '../../Constants';
import { NewAccordion } from '../Home/NewAccordion';

const FAQ_IDS = [14, 18, 8, 15, 12];
const normalizeFaqTitle = (title) =>
  String(title || '')
    .trim()
    .toLocaleLowerCase()
    .replace(/[’‘`]/g, "'")
    .replace(/\s+/g, ' ');

const ProductSuggestionWhyRiise = ({
  viewHalf = false,
  viewOtherHalf = false,
  pickedFaqsShow = false,
  borderBottom = false,
  hideQuizFaq = false,
  excludedFaqTitles = [],
}) => {
  const [data, setData] = useState([]);
  const [pickedFaqs, setPickedFaqs] = useState([]);
  const [faqItems, setFaqItems] = useState([]);
  const [skip] = useState(false);

  const selectedLang = useSelector(selectCurrentLanguage);
  const [lang, setLang] = useState('');
  const { t } = useTranslation();
  const normalizedExcludedFaqTitles = excludedFaqTitles.map(normalizeFaqTitle);
  const visiblePickedFaqs = pickedFaqs.filter(
    (item) => !normalizedExcludedFaqTitles.includes(normalizeFaqTitle(item?.title)),
  );

  const { data: fetchRecords, isSuccess, refetch } = useGetRecordQuery({ lang: lang, skip: skip });

  useEffect(() => {
    if (isSuccess && fetchRecords?.data) {
      const allFaqs = fetchRecords.data.filter((item) => item.category === 'faq');
      setData(fetchRecords.data);
      setFaqItems(allFaqs);
      const result = fetchRecords?.data
        ?.filter((item) => FAQ_IDS.includes(item.id))
        .sort((a, b) => FAQ_IDS.indexOf(a.id) - FAQ_IDS.indexOf(b.id));
      setPickedFaqs(result);
    }
  }, [fetchRecords, isSuccess]);

  useEffect(() => {
    setLang(selectedLang === 'us' ? 'en' : selectedLang);

    refetch();
  }, [refetch, lang, selectedLang]);

  if (viewHalf) {
    return (
      <div className="t-flex t-flex-col t-gap-2">
        <NewAccordion heading={`${t(WhyRiiseTitle)}?`} borderBottom={borderBottom}>
          {data &&
            data.map((item, index) =>
              item.category === 'whyriise' ? (
                <div className="t-flex t-items-starts t-gap-1" key={'whiriise' + index}>
                  {item.picture && (
                    <img
                      src={`${process.env.REACT_APP_PUBLIC_URL}${item.picture}`}
                      alt=""
                      className="t-h-6 t-w-8 t-object-cover"
                    />
                  )}
                  <div className="t-flex t-flex-col t-gap-0">
                    <p className="t-font-bold">{item.title}</p>
                    <p>{item.description}</p>
                  </div>
                </div>
              ) : (
                ''
              )
            )}
        </NewAccordion>
        {faqItems.slice(1, 3).filter((item) => !hideQuizFaq || !item.title?.toLowerCase().includes('quiz')).map((item, index) => (
          <NewAccordion heading={item.title} key={`faq-${index}`} borderBottom={borderBottom}>
            <p>{item.description}</p>
          </NewAccordion>
        ))}
        {faqItems.slice(9, 11).filter((item) => !hideQuizFaq || !item.title?.toLowerCase().includes('quiz')).map((item, index) => (
          <NewAccordion heading={item.title} key={`faq-${index}`} borderBottom={borderBottom}>
            <p>{item.description}</p>
          </NewAccordion>
        ))}
      </div>
    );
  } else if (viewOtherHalf) {
    const filterQuiz = (item) => !hideQuizFaq || !item.title?.toLowerCase().includes('quiz');
    return (
      <div className="t-flex t-flex-col t-gap-2">
        {faqItems.slice(0, 1).filter(filterQuiz).map((item, index) => (
          <NewAccordion heading={item.title} key={`faq-${index}`} borderBottom={borderBottom}>
            <p>{item.description}</p>
          </NewAccordion>
        ))}
        {faqItems.slice(3, 9).filter(filterQuiz).map((item, index) => (
          <NewAccordion heading={item.title} key={`faq-${index}`} borderBottom={borderBottom}>
            <p>{item.description}</p>
          </NewAccordion>
        ))}
        {faqItems.slice(11).filter(filterQuiz).map((item, index) => (
          <NewAccordion heading={item.title} key={`faq-${index}`} borderBottom={borderBottom}>
            <p>{item.description}</p>
          </NewAccordion>
        ))}
      </div>
    );
  } else if (pickedFaqsShow) {
    return (
      <div className="t-flex t-flex-col t-gap-2">
        <NewAccordion heading={`${t(WhyRiiseTitle)}?`} borderBottom={borderBottom}>
          {data &&
            data.map((item, index) =>
              item.category === 'whyriise' ? (
                <div className="t-flex t-items-starts t-gap-1" key={'whiriise' + index}>
                  {item.picture && (
                    <img
                      src={`${process.env.REACT_APP_PUBLIC_URL}${item.picture}`}
                      alt=""
                      className="t-h-6 t-w-8 t-object-cover"
                    />
                  )}
                  <div className="t-flex t-flex-col t-gap-0">
                    <p className="t-font-bold">{item.title}</p>
                    <p>{item.description}</p>
                  </div>
                </div>
              ) : (
                ''
              )
            )}
        </NewAccordion>
        {visiblePickedFaqs.map((item, index) => (
          <NewAccordion heading={item.title} key={`faq-${index}`} borderBottom={borderBottom}>
            <p>{item.description}</p>
          </NewAccordion>
        ))}
        <NewAccordion heading={t(DoINeedAboLabel)} borderBottom={borderBottom}>
          <p>{t(DoINeedAboAnswer)}</p>
        </NewAccordion>
      </div>
    );
  }
  return (
    <div className="t-flex t-flex-col t-gap-2">
      <NewAccordion heading={`${t(WhyRiiseTitle)}?`} borderBottom={borderBottom}>
        {data &&
          data.map((item, index) =>
            item.category === 'whyriise' ? (
              <div className="t-flex t-items-starts t-gap-1" key={'whiriise' + index}>
                {item.picture && (
                  <img
                    src={`${process.env.REACT_APP_PUBLIC_URL}${item.picture}`}
                    alt=""
                    className="t-h-6 t-w-8 t-object-cover"
                  />
                )}
                <div className="t-flex t-flex-col t-gap-0">
                  <p className="t-font-bold">{item.title}</p>
                  <p>{item.description}</p>
                </div>
              </div>
            ) : (
              ''
            )
          )}
      </NewAccordion>
      {faqItems.map((item, index) => (
        <NewAccordion heading={item.title} key={`faq-${index}`} borderBottom={borderBottom}>
          <p>{item.description}</p>
        </NewAccordion>
      ))}
    </div>
  );
};

export default ProductSuggestionWhyRiise;
